import { defineStore } from 'pinia';
import { useProductProcessDefinitionDetailStore } from './product-process-definition-detail.store';

export enum ProductProcessDefinitionEditType {
    ProductProcessDefinition,
    SourceEntity,
    ProductTransformationLookupLink,
    ProductSpecification,
    ProductEntity,
    ProductEntityLink,
    SourceSpecification,
    ProductTransformation,
    ProductEntityDataMapping,
}
export interface ProductProcessDefinitionEditStoreState {
    create?: {
        type?: ProductProcessDefinitionEditType;
    };
    edit?: {
        key?: number;
        type?: ProductProcessDefinitionEditType;
    };
}

export const useProductProcessDefinitionEditStore = defineStore('configuration-product-process-definition-edit-store', {
    state: (): ProductProcessDefinitionEditStoreState => ({
        create: null,
        edit: null,
    }),
    getters: {
        canEdit(): boolean {
            return useProductProcessDefinitionDetailStore().isDraft;
        },
        isCreate(): (type: ProductProcessDefinitionEditType) => boolean {
            return (type: ProductProcessDefinitionEditType) => this.create?.type === type;
        },
        creating(): boolean {
            return this.create !== null && this.create?.type !== null;
        },
        isEdit(): (type: ProductProcessDefinitionEditType, id: number) => boolean {
            return (type: ProductProcessDefinitionEditType, id: number) =>
                this.edit?.type === type && this.edit?.key === id;
        },
        editing(): boolean {
            return this.edit !== null && this.edit?.type !== null && this.edit?.key !== null;
        },
    },
    actions: {
        init(){
            this.create = null;
            this.edit = null;
        },
        openCreate(type: ProductProcessDefinitionEditType) {
            this.create = { type };
            this.edit = null;
        },
        closeCreate() {
            this.create = null;
        },
        openEdit(type: ProductProcessDefinitionEditType, key: number) {
            this.edit = { type, key };
            this.create = null;
        },
        closeEdit() {
            this.edit = null;
        },
    },
});
